import React from 'lib/react';
import PropTypes from 'prop-types';
import { makeStyles } from 'lib/components';

const useStyles = makeStyles(() => ({
  svg: ({ color }) => ({
    '& path': {
      fill: color,
    },
  }),
}));
function CustomSvgIcon({
  svgString, color, width, height, ...props
}) {
  const classes = useStyles({ color });
  const innerHtml = new DOMParser().parseFromString(svgString, 'text/html').body.firstChild.innerHTML;

  return (
    <svg
      className={classes.svg}
      style={{
        width,
        height,
        ...props.style,
      }}
      // #genai This component's sole purpose is to render a caller-supplied SVG string as inline
      // markup, so dangerouslySetInnerHTML is required. The value is derived from the `svgString`
      // prop via DOMParser above; callers pass trusted, app-controlled SVG assets (not user input).
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: innerHtml }}
    />
  );
}

CustomSvgIcon.defaultProps = {
  width: '24px',
  height: '24px',
  color: 'black',
  style: {},
};
CustomSvgIcon.propTypes = {
  svgString: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  style: PropTypes.shape(),

};

export default CustomSvgIcon;
